








































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import CurrencyModule from '@/store/modules/Currency';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import MemberBody from '@/components/Table/MemberBody.vue';
import NewMemberBody from '@/components/Table/NewMemberBody.vue';
import ELasticMemberBody from '@/components/Table/WinloseElasticBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import WinLoseData from '@/data/WinLoseData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import utils from '@/services/utils';
import cryptoJs from 'crypto-js';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    MemberBody,
    NewMemberBody,
    ELasticMemberBody,
    LogBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  componentKey = 0;

  Criteria = {
    ...this.Period,
    isSearch: false,
    gameName: ['total'],
    products: ['total'],
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    limit: 100,
    page: 1,
    isNewWinlose: false,
    isElastic: false,
  };

  DefaultGameList = [
    {
      name: {
        en: 'Total',
        th: 'ทั้งหมด',
      },
      prefix: 'total',
    },
  ];

  GameList: any = [];

  BreadcrumbList: any = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  WinLoseList: any = {};

  resultData: any = {};

  dataList: any = [];

  LoginName = '';

  TableHeadMember = [...WinLoseData.TableHeadMember];

  FilteredTableHeadMember: any = [...WinLoseData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  dataKey = 'users';

  isMember = false;

  detailFooterCol = 0;

  totalLog = 0;

  summaryLog = 0;

  houseEdge: any = [];

  totalCurrency: any = [];

  isMultiCurrency = true;

  startDate = '';

  endDate = '';

  // isFetchNewWinloseTemporary = false;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  created() {
    this.fetchGame();
    this.handleFetchWinLose();
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      gameName: ['total'],
      products: ['total'],
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      limit: 100,
      page: 1,
      isNewWinlose: false,
      isElastic: false,
    };
    this.LoginName = '';
    this.isMember = false;
  }

  ToggleFetchNewWinlose() {
    this.Criteria.isNewWinlose = !this.Criteria.isNewWinlose;
    this.Criteria.isElastic = false;
    this.handleFetchWinLose();
  }

  ToggleFetchElastic() {
    this.Criteria.isElastic = !this.Criteria.isElastic;
    this.Criteria.isNewWinlose = false;
    this.handleFetchWinLose();
  }

  handleTableCurrency() {
    this.isMultiCurrency = !this.isMultiCurrency;
    this.handleFetchWinLose();
  }

  handleBetType({ target: { checked, value } }) {
    if (value === 'total') {
      this.Criteria.gameName = checked ? this.GameList.map((item) => item.value) : [];
    } else if (value !== 'total') {
      if (checked) {
        this.Criteria.gameName.push(value);
        if (this.Criteria.gameName.length === this.GameList.length - 1) {
          this.Criteria.gameName.push('total');
        }
      } else {
        this.Criteria.gameName = this.Criteria.gameName.filter(
          (item) => item !== value && item !== 'total',
        );
      }
    }
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.handleFetchWinLose();
  }

  async fetchWinlose() {
    // this.isFetchNewWinloseTemporary = this.Criteria.isNewWinlose;
    let res: any;
    this.Criteria.isSearch = !!this.LoginName;
    const criteria: any = { ...this.Criteria, ...this.Period };
    criteria.products = criteria.gameName;
    criteria.isMultiCurrency = this.isMultiCurrency;

    const isProductTotal = !!criteria.products.find((game) => game.toLowerCase() === 'total');
    if (isProductTotal) criteria.products = ['total'];

    // const startDate = this.$moment(this.Period.start.date).format('YYYYMMDD');
    // const endDate = this.$moment(this.Period.end.date).format('YYYYMMDD');
    // const DATE_FOR_FETCH_REPORT_WITH_NEW_WINLOSE = ['20220208', '20220209',
    // '20220210', '20220211', '20220212', '20220213', '20220214'];
    // const isFetchWithNewWinlose = DATE_FOR_FETCH_REPORT_WITH_NEW_WINLOSE.includes(startDate)
    //   && DATE_FOR_FETCH_REPORT_WITH_NEW_WINLOSE.includes(endDate);

    // if (isFetchWithNewWinlose) {
    //   criteria.isNewWinlose = true;
    //   this.isFetchNewWinloseTemporary = true;
    // }

    if (!this.Criteria.isElastic) {
      const { data, status } = await this.ReportInstance.FetchWinLose(criteria);
      res = data;
      this.checkError(status);
      this.GeneralInstance.toggleLoading(false);
    } else {
      const { data, status } = await this.ReportInstance.FetchWinLoseElastic(criteria);
      this.checkError(status);
      this.GeneralInstance.toggleLoading(false);
      this.WinloseElastic(data);
    }

    if (
      ['COMPANY', 'SUPERADMIN', 'SUBCOMPANY'].includes(this.Criteria.role && this.AuthInstance.role)
    ) {
      this.FilteredTableHeadMember[0] = [...WinLoseData.TableHeadMember[0]].filter(
        (item: any) => !item.isCompanyHidden,
      );
    } else {
      this.FilteredTableHeadMember = [...WinLoseData.TableHeadMember];
      this.FilteredTableHeadMember[0] = [...WinLoseData.TableHeadMember[0]].filter(
        (item: any) => !item.isAnyHidden,
      );
    }

    if (res.footerSummary.length) this.resultData.footerSummary = res.footerSummary;
    else this.resultData.footerSummary = [];

    if (!res.users.length) {
      this.PaginationDetail.amount = 0;
      this.PaginationDetail.current = 0;
    }

    this.houseEdge = this.resultData.footerSummary.map((item: any) => ({
      houseEdge: (item.rawByGame / item.turnover) * -100,
      currency: item.currency ? item.currency : 'THB',
    })) || 0;

    if (criteria.isNewWinlose) {
      this.houseEdge = this.resultData.footerSummary.map((item: any) => ({
        houseEdge: (item.rawWinlose / item.turnover) * -100,
        currency: item.currency ? item.currency : 'THB',
      })) || 0;
    }

    this.type = 'dataWinLose';
    this.dataKey = 'users';
    this.mode = 'agent';

    this.BreadcrumbList = [...this.BreadcrumbDefault, ...res.breadcrumb];

    this.PaginationDetail.amount = res.pageAmount;
    this.resultData = res;

    // if (!this.Criteria.isNewWinlose && !this.isFetchNewWinloseTemporary) {
    if (!this.Criteria.isNewWinlose) {
      const totalCC = await this.CurrencyInstance.fetchCurrencyRate();
      if (this.isMultiCurrency) {
        const query = {};
        const currencys = totalCC.currency;
        currencys.forEach((v: any) => {
          this.resultData.users.forEach((w: any) => {
            if (v === w.currency) {
              if (query[v]) query[v] = [...query[v], w.currency].sort();
              else query[v] = [w];
            }
            if (v !== w.currency && !query[v]) query[v] = [];
          });
        });
        const dataCurrency = this.resultData.users.map((item: any) => (item.currency ? item.currency : 'THB'));
        this.totalCurrency = [...new Set(dataCurrency)];
      } else {
        const dataCurrency = this.resultData.users.map((item: any) => (item.currency ? item.currency : 'THB'));
        this.totalCurrency = [...new Set(dataCurrency)];
      }
    } else {
      this.totalCurrency = res.users
        .filter((item) => item.report.length)
        .map((item) => item.currency);
    }
  }

  WinloseElastic(data: any) {
    if (
      ['COMPANY', 'SUPERADMIN', 'SUBCOMPANY'].includes(this.Criteria.role && this.AuthInstance.role)
    ) {
      this.FilteredTableHeadMember[0] = [...WinLoseData.TableHeadMember[0]].filter(
        (item: any) => !item.isCompanyHidden,
      );
    } else {
      this.FilteredTableHeadMember = [...WinLoseData.TableHeadMember];
      this.FilteredTableHeadMember[0] = [...WinLoseData.TableHeadMember[0]].filter(
        (item: any) => !item.isAnyHidden,
      );
    }

    if (data.summary.length) {
      this.resultData.footerSummary = data.summary;
      this.houseEdge = data.summary.map((items: any) => ({
        houseEdge: (items.rawWinlose / items.turnover) * -100,
        currency: items._id,
      }));
    }

    this.type = 'dataWinLose';
    this.dataKey = 'users';
    this.mode = 'agent';

    this.BreadcrumbList = [...this.BreadcrumbDefault, ...data.breadcrumb];
    this.PaginationDetail.amount = data.pageAmount;
    this.resultData = data;

    if (this.isMultiCurrency) {
      this.totalCurrency = data.report.filter((item) => item.user.length).map((item) => item._id);
    } else {
      const dataCurrency = data.report.map((item: any) => (item.currency ? item.currency : 'THB'));
      this.totalCurrency = [...new Set(dataCurrency)];
    }

    if (!this.resultData.report.length) {
      this.totalCurrency = ['THB'];
      this.houseEdge = [{
        houseEdge: 0,
        currency: 'THB',
      }];
      this.PaginationDetail.amount = 0;
      this.PaginationDetail.current = 1;
    }
  }

  async fetchBetTransaction() {
    this.Criteria.isSearch = !!this.LoginName;
    const criteria: any = { ...this.Criteria, ...this.Period };
    criteria.products = criteria.gameName;
    criteria.currentPage = this.PaginationDetail.current;
    criteria.sizePage = this.PaginationDetail.size;

    const res = await this.ReportInstance.FetchWinLoseLog(criteria);

    if (res.code) {
      this.checkError(res);
      this.GeneralInstance.toggleLoading(false);
    }

    if (typeof res === 'object' && res.result.length) {
      this.TableHeadLog = [...WinLoseData.TableHeadLog];
      this.TableHeadLog[1] = [...WinLoseData.TableHeadLog[1]];
      const { tableHeader } = this.ReportInstance.dataWinLoseLog;
      tableHeader.forEach((val, idx) => {
        this.TableHeadLog[1].push({
          displayName:
            idx === tableHeader.length - 2
              ? 'report.winloseSimple.datatable.company'
              : idx === tableHeader.length - 1
                ? 'report.winloseSimple.datatable.api'
                : 'report.winloseSimple.datatable.agent',
          attr: {
            class: 'text-right',
            style: 'top:32px;',
          },
          index: idx < tableHeader.length - 2 ? tableHeader.length - 2 - idx : 0,
        });
      });
      this.detailFooterCol = tableHeader.length + 2;
      this.totalLog = this.ReportInstance.dataWinLoseLog.total;
      this.summaryLog = this.ReportInstance.dataWinLoseLog.netwin;
    } else {
      this.totalLog = 0;
      this.summaryLog = 0;
    }

    this.type = 'dataWinLoseLog';
    this.dataKey = 'result';
    this.mode = 'member';

    if (!res.result.length) {
      this.PaginationDetail.amount = 0;
      this.PaginationDetail.current = 0;
    }

    this.BreadcrumbList = [...this.BreadcrumbDefault, ...res.breadcrumb];

    this.PaginationDetail.amount = res.pageAmount;
    this.resultData = res;

    const dataCurrency = this.resultData.result.map((item: any) => item.currency);
    this.totalCurrency = dataCurrency.filter((item, i) => dataCurrency.indexOf(item) === i);
    this.resultData[this.dataKey] = res.result;
    if (this.type === 'dataWinLose') {
      this.resultData[this.dataKey].sort((a, b) => b.transaction.turnover - a.transaction.turnover);
    }
  }

  async handleFetchWinLose() {
    this.GeneralInstance.toggleLoading(true);
    if (this.isMember) {
      await this.fetchBetTransaction();
    } else {
      await this.fetchWinlose();
    }
    this.componentKey += 1;
    this.GeneralInstance.toggleLoading(false);
  }

  async fetchResult(params) {
    const {
      roundId, username, categories, data, currency, rateCurrency, product,
    } = params;
    const isAmbslot = ['slot', 'fishing', 'arcade'].includes(categories);
    const width = (params.categories === 'arcade' && params.product !== 'PUNPAE') || ['BINGO', 'BINGO2', 'fishing'].includes(params.product)
      ? 1305
      : 700;
    const height = params.categories === 'arcade' || ['BINGO', 'BINGO2'].includes(params.product)
      ? 630
      : 750;
    const strWindowFeatures = `top=0,left=0,height=${height},width=${width},scrollbars=yes`;
    if (isAmbslot) {
      const reqParams = {
        username,
        roundId: ['slot', 'arcade'].includes(categories) ? data[0].ambslotId : roundId,
        categories,
        language: this.$i18n.locale,
        isAmbPoker: ['slot', 'arcade', 'fishing'].includes(categories),
        provider: 'AMBSLOT',
        currency,
        rateCurrency,
      };
      const res = await this.ReportInstance.FetchNewTransaction(reqParams);
      this.checkError(res.status);
      window.open(res.data.url, 'gameResult', strWindowFeatures);
    } else {
      const param = {
        roundId,
        username,
        prefix: product,
        currency: {
          abb: currency,
          rate: rateCurrency,
        },
        language: this.$i18n.locale,
        source: params.data[0].source,
      };
      const res = await this.ReportInstance.FetchTransaction(param);
      const encrypt = cryptoJs.AES.encrypt(
        JSON.stringify(param),
        '4141DF79AEA07A075549AA6AEB1D7824',
      );
      const url = res.url.charAt(res.url.length - 1) !== '/' ? `${res.url}/` : res.url;
      const link = `${url}?t=${utils.getUserPersistent().token}&p=${encrypt.toString()}`;
      window.open(link, 'gameResult', strWindowFeatures);
    }
  }

  async fetchGame() {
    const res = await this.GameInstance.FetchGame();
    if (res.code) {
      this.checkError(res);
    } else {
      await this.mapGameInput();
      this.Criteria.gameName = this.GameList.map((item) => item.value);
    }
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    if (this.$i18n.locale) {
      this.mapGameInput();
    }
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  async mapGameInput() {
    const games = await this.GameInstance.game;
    this.GameList = [...this.DefaultGameList, ...games].map((g) => ({
      name: g.name[this.$i18n.locale],
      value: g.prefix.toLowerCase(),
    }));
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.handleFetchWinLose();
  }

  onSubmit() {
    this.handleFetchWinLose();
  }

  onReset() {
    this.initial();
    this.handleFetchWinLose();
  }

  handleSearch() {
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName ? this.LoginName : this.AuthInstance.user.username;
  }

  handleFetchWinloseAgent(username, role, source) {
    this.beforeFetch(username, role, source);
  }

  handleFetchWinloseAgentElastic(items) {
    this.beforeFetchElastic(items);
  }

  handleGame() {
    this.handleFetchWinLose();
  }

  handleBreadcrumb(items) {
    this.Criteria.page = 1;
    if (this.Criteria.isElastic) {
      this.Criteria.isNewWinlose = false;
      this.houseEdge = [{
        houseEdge: 0,
        currency: ['THB'],
      }];
      this.beforeFetchElastic(items);
    } else {
      const { username, role, source } = items;
      this.beforeFetch(username, role, source);
    }
  }

  beforeFetch(username, role, source) {
    this.isMember = role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = username;
    this.Criteria.source = source;
    this.Criteria.role = role;
    this.PaginationDetail.current = 1;
    this.handleFetchWinLose();
  }

  beforeFetchElastic(items) {
    this.isMember = items.role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = items.username;
    this.Criteria.source = items.source;
    this.Criteria.role = items.role;
    this.Criteria.userId = items.id || items._id;
    this.Criteria.isNewWinlose = false;
    this.PaginationDetail.current = 1;
    this.handleFetchWinLose();
  }
}
